import { randomBytes } from '@ethersproject/random';
import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator, ImageBackground } from 'react-native';
import { CheckBox, Button, Avatar } from 'react-native-elements';

const { IMG_DATA, IMG_WIDE, USDT } = require('../Data');

class PanelWarriors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy'
    };
  }

  async componentDidMount() {
    this.setState({ show: 'game' });
  }

  componentWillUnmount() {
  }

  renderCell(data) {
    const s = { textAlign: 'center', fontSize: 10, color: 'white', fontWeight: 'bold' };
    let m = 1.7;
    return (
      <View key={data.index} style={{ flex: 1, padding: 10 }}>
        <ImageBackground source={{
          uri: data.url,
        }} resizeMode="cover" style={{ flex: 1, padding: 10 }} >
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <Text style={s}>{data.name.toUpperCase()}</Text>
          <Text style={s}>POWER: {data.power}</Text>
          <Text style={s}>{data.mint} {USDT}</Text>
          <Text style={s}>{data.chance}%</Text>
        </ImageBackground>
      </View >
    );
  }

  render() {
    const imgData = IMG_DATA;
    const rows1d = [];

    for (let i = 0; i < imgData.length; i++) {
      const id = imgData[i];
      const name = id.name;
      const mint = id.mintFee;
      const power = id.power;
      const chance = id.chance;

      let url = id.img;

      if (i === 0) {
        url = IMG_WIDE;
      }

      rows1d.push({ index: i, name, power, mint, chance, url });

    }

    let rows2d = [];
    let cells = [];
    for (let i = 0; i < rows1d.length; i++) {
      cells.push(rows1d[i]);
      if (i == 0) {
        rows2d.push(cells);
        cells = [];
      } else {
        if (cells.length === 3) {
          rows2d.push(cells);
          cells = [];
        }
      }
    }

    if (cells.length > 0) {
      rows2d.push(cells);
    }

    const rows = rows2d;

    return (
      <View style={{ backgroundColor: 'black' }}>
        {rows.map((cols, index) =>
          <View key={index} style={{ flexDirection: 'row' }}>
            {cols.map((cell) => this.renderCell(cell))}
          </View>
        )}
      </View>
    );
  }

}

export default PanelWarriors;
